/*
 * Copyright (c) Worldline 2023.
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {HttpService} from "../../http/http.service";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {DomSanitizer} from "@angular/platform-browser";
import {CertificateService} from "../../services/certificate.service";
import {SignerService} from "../../services/signer.service";


@Component({
    selector: 'wl-certificate-approval',
    templateUrl: './wl-certificate-approval.component.html'
})
export class WlCertificateApprovalComponent implements OnInit {
    // Inputs required
    /**
     * The pdf name for download button
     */
    @Input()
    multipledocuments: any;


    // Information to show on front
    firstName: string;
    lastName: string;

    @Input()
    certificateValidation: any;
    @Output() certificateValidationChange = new EventEmitter<any>();

    // Link is updated at startup
    link = null;

    showDetails : boolean = false;


    constructor( private router: Router,private route: ActivatedRoute, private httpClient: HttpService, private signersService: SignerService,private translate: TranslateService,private sanitizer: DomSanitizer,private certificateService : CertificateService) {

        this.firstName = signersService.currentSigner.firstName;
        this.lastName = signersService.currentSigner.lastName;
    }

    ngOnInit(): void {
        this.showDetails = false;

        this.certificateValidation =  {
            gcs: false,
            certificate: false
        };

        this.link = this.certificateService.createGcsLink();
    }


    openGcs() {
        if (this.link !== null) {
            window.open(this.link, '_blank');
        }
    }

    // Trick to be able to pass a function to a child component
    getOpenGcs() {
        return () => {
            return this.openGcs()
        }
    }


    updateCertificateValidation() {
        this.certificateValidationChange.emit(this.certificateValidation);
    }
}
